import React from 'react';
import { useField, useFormikContext } from 'formik';
import classNames from 'classnames';

import Error from 'client/components/common/Error';

import css from './SchedulePopup.module.scss';

export interface Option {
  label: string;
  value: string;
}

interface Props {
  name: string;
  label: string;
  options: Option[];
}

export const TimeSpots: React.FC<Props> = ({ name, label, options }) => {
  const { setFieldValue } = useFormikContext<any>();
  const [field, meta] = useField<string>(name);
  const errorMsg = !!(meta.touched && meta.error) ? meta.error : '';

  const selectedValues = field.value ? field.value.split(',') : [];

  const toggleValue = (value: string) => {
    const updated = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    setFieldValue(name, updated.join(','));
  };

  return (
    <div className={css.timeSpotsWrap}>
      <p className={css.label}>{label}</p>
      <div className={css.timeSpots}>
        {options.map((option) => {
          const isActive = selectedValues.includes(option.value);

          return (
            <button
              key={option.value}
              type="button"
              className={classNames(css.button, isActive && css.active)}
              onClick={() => toggleValue(option.value)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      {errorMsg && meta.touched && <Error name={name} error={errorMsg} />}
    </div>
  );
};
